import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/order-actions.module.scss';
import { IOrder } from 'src/types/order';
import DeleteOrderAction from './DeleteOrderAction';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';

const OrderActionsColumn: React.FunctionComponent<CellProps<IOrder>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IOrder>) => {
    if (!user.getRoles().includes(UserRole.ROLE_ADMIN)) {
        return null;
    }
    return (
        <div className={classNames(styles.actions)}>
            <Link className="btn btn-info" to={Router.generate(routes.ORDER_EDIT, { id: original.id })}>
                <FontAwesomeIcon icon={faPencilAlt} />
            </Link>
            <DeleteOrderAction data={original} />
        </div>
    );
};

export default OrderActionsColumn;
